export const PANEL_DEFAULT_WIDTH = 420;
export const PANEL_DEFAULT_MAX_HEIGHT = 704;
export const PANEL_MIN_WIDTH = PANEL_DEFAULT_WIDTH;
export const PANEL_MIN_HEIGHT = PANEL_DEFAULT_MAX_HEIGHT;
export const PANEL_DEFAULT_RIGHT = 24;
export const PANEL_DEFAULT_BOTTOM = 20;
export const PANEL_VIEWPORT_PADDING = 10;
export const PANEL_VIEWPORT_VERTICAL_GAP = 40;
export const PANEL_MAX_WIDTH_VIEWPORT_FUDGE = 80;
export const PANEL_BORDER_RADIUS = 16;
export const PANEL_RESIZE_HANDLE_SIZE = 20;
export const PANEL_RESIZE_ICON_SIZE = 10;
export const FAB_IDLE_BORDER_RADIUS = 36;
export const FAB_DEFAULT_RIGHT_CLASS = "right-[24px]";

export const FLOATING_WIDGET_LAYOUT_ID = "floating-widget";

export const floatingWidgetMorphSpring = {
  type: "spring" as const,
  stiffness: 500,
  damping: 30,
  mass: 0.7,
};

export const floatingWidgetExitTransition = { duration: 0.18, ease: [0.4, 0, 1, 1] as const };

export interface PanelSize {
  width: number;
  height: number;
}

export interface PanelPosition {
  x: number;
  y: number;
}

export const DEFAULT_PANEL_POSITION: PanelPosition = { x: 0, y: 0 };

export const getDefaultPanelHeight = () =>
  Math.min(PANEL_DEFAULT_MAX_HEIGHT, window.innerHeight - PANEL_VIEWPORT_VERTICAL_GAP);

export const getDefaultPanelSize = (): PanelSize => ({
  width: PANEL_DEFAULT_WIDTH,
  height: getDefaultPanelHeight(),
});

export const getMaxPanelWidth = () =>
  window.innerWidth - PANEL_DEFAULT_RIGHT - PANEL_VIEWPORT_PADDING - PANEL_MAX_WIDTH_VIEWPORT_FUDGE;

export const getMaxPanelHeight = () => window.innerHeight - PANEL_VIEWPORT_VERTICAL_GAP;

export const clampPanelSize = (size: PanelSize): PanelSize => ({
  width: Math.min(getMaxPanelWidth(), Math.max(PANEL_MIN_WIDTH, size.width)),
  height: Math.min(getMaxPanelHeight(), Math.max(PANEL_MIN_HEIGHT, size.height)),
});
